import { FormSection } from 'framework/ui/layout';
import { DateInput, useFormContext, TextInput } from 'framework/form';
import { Grid2 as Grid } from '@mui/material';

const ExternalReportForm = () => {
  const { data = {} } = useFormContext();

  return (
    <>
      <FormSection>
        <Grid
          container
          spacing={2}
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Grid container spacing={2} direction="row" size={12}>
            <Grid size={6}>
              <DateInput
                source="periodStart"
                label="Period from"
                minDate={data.lastReportPeriodEnd}
                maxDate={data.periodEnd}
                validRangeInclusivity="[)"
              />
            </Grid>
            <Grid size={6}>
              <DateInput source="periodEnd" label="Period to" minDate={data.periodStart} validRangeInclusivity="()" />
            </Grid>
          </Grid>
          <Grid size={12}>
            <TextInput source="externalReportLink" label="Provide the report link" />
          </Grid>
        </Grid>
      </FormSection>
    </>
  );
};

export default ExternalReportForm;
